export default __webpack_public_path__ + "static/media/logo.38b7af7f.svg";